/**
 * TrainerNav — bottom navigation bar for trainer users
 */
import { NavLink } from 'react-router-dom';
import Icon from '../common/Icon';

const navItems = [
  { to: '/trainer/dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
  { to: '/trainer', label: 'Clients', icon: 'Users' },
  { to: '/trainer/messages', label: 'Messages', icon: 'MessageCircle' },
  { to: '/trainer/invite', label: 'Invite', icon: 'Mail' },
];

const TrainerNav = () => {
  return (
    <nav className="bottom-nav" aria-label="Trainer navigation">
      <div className="bottom-nav__inner">
      {navItems.map(({ to, label, icon }) => (
        <NavLink
          key={to}
          to={to}
          data-nav-direction="lateral"
          className={({ isActive }) =>
            `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`
          }
          end={to === '/trainer'}
        >
          <Icon name={icon} size={20} className="bottom-nav__icon" aria-hidden="true" />
          <span className="bottom-nav__label">{label}</span>
        </NavLink>
      ))}
      </div>
    </nav>
  );
};

export default TrainerNav;
